import React, { createContext, useState, useContext } from 'react';
import { translations } from '../config/I18NConfig';

const I18nContext = createContext();
export const I18nProvider = ({ children }) => {
    const [locale, setLocale] = useState('en'); // Default locale
    const t = (key) => {
        return translations[locale][key] || key; // Fallback to key if translation not found
    };
    return (
        <I18nContext.Provider value={{ locale, setLocale, t }}>
            {children}
        </I18nContext.Provider>
    );
};
export const useTranslation = () => {
    return useContext(I18nContext);
};
